import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { AccountAPI } from "../../../axios/api";
import { useAbortedEffect, useHookForm } from "../../../components/hooks";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import {
  FormInputtext,
  FormDropdown,
} from "../../../components/formElement/index";
import { formatResData, checkFormUpdate } from "../../../service/common";
import { option_account_type } from "../../../service/option";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export default function BackAccountDetail() {
  const route_params = useParams();
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const crumbItem = [
    {
      key: 1,
      label: "帳號管理",
      command: () => route_navigate("/back/account"),
    },
    {
      key: 2,
      label: "編輯",
    },
  ];
  const [reload, setReload] = useState({
    list: true,
  });
  const disabled = true;
  // 明細資料
  const [apiData, setApiData] = useState({});
  // 表單欄位預設值
  const defaultValues = {
    username: "",
    name: "",
    type: null,
  };
  const { handleSubmit, reset, trigger, yup, setSchema, errors, setting } =
    useHookForm({
      defaultValues,
    });

  useEffect(() => {
    setSchema(
      yup
        .object({
          username: yup.string().required("必填"),
          // name: yup.string().required("必填"),
        })
        .required()
    );
  }, []);

  useAbortedEffect(
    (signal) => {
      if (!reload.list || route_params.detailid === "add") {
        return;
      }

      dispatch(setProgress(true));

      let params = { id: route_params.detailid };

      AccountAPI.getUserListDeatils({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          let temp = formatResData(defaultValues, data);
          setApiData(temp);
          reset(temp);
          setReload((state) => ({ ...state, list: false }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  // 表單驗證成功後，呼叫 API
  const onSubmit = (submitData) => {
    dispatch(setProgress(true));

    let jsonData = {
      ...submitData,
    };

    if (!checkFormUpdate(jsonData, apiData)) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "無資料變更",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      route_navigate("/back/account");
      return;
    }

    let promise,
      toast = "";
    if (route_params.detailid === "add") {
      // 新增
      // promise = AccountAPI.setAccountData({
      //   data: jsonData,
      // });
      toast = "新增";
    } else {
      // 修改
      delete jsonData.username;
      jsonData.id = Number(route_params.detailid);
      promise = AccountAPI.updateAccountData({
        data: jsonData,
      });
      toast = "編輯";
    }

    promise.then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: `${toast}成功`,
            detail: "",
          })
        );
        route_navigate("/back/account");
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `${toast}失敗`,
            detail: message ?? "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <h2 className="my-3 ml-1">帳號管理 - 編輯</h2>

      <div className="border-round-lg bg-white mt-3 p-3">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="username"
              className={classNames(
                { "p-error": errors.username },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              帳號
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputtext
                setting={setting}
                data={{
                  name: "username",
                  disabled: route_params.detailid !== "add" || disabled,
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="name"
              className={classNames(
                { "p-error": errors.name },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              姓名
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputtext
                setting={setting}
                data={{
                  name: "name",
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="type"
              className={classNames(
                { "p-error": errors.type },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              帳號類型
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormDropdown
                setting={setting}
                data={{
                  name: "type",
                  options: option_account_type,
                  optionLabel: "label",
                  optionValue: "value",
                  showClear: false,
                }}
              />
            </div>
          </div>

          <div className="field col-12 text-right">
            <Button
              type="button"
              label="取消"
              className="p-button-secondary p-button-outlined ml-auto px-3"
              onClick={() => route_navigate("/back/account")}
            />
            {/* {!disabled && ( */}
            <Button type="submit" label="儲存" className="ml-2 px-3" />
            {/* )} */}
          </div>
        </form>
      </div>
    </>
  );
}
